import React from 'react';

import {
  Stack,
} from '@mui/material';

import {
  useGetLessonsQuery,
} from '../../../services/classes';
import { Class, Lesson } from '../../../services/classes/types';
import { Metadata } from '../../../services/types';

import ClassCard from './ClassCard';
import LessonsCard from './LessonsCard';
import ScheduleCard from './ScheduleCard';
import StudentsCard from './StudentsCard';

interface DetailsTabProps {
  classObj: Class,
  metadata?: Metadata,
  setSelectedLesson: (lesson?: Lesson) => void,
  selectedLesson?: Lesson,
}

const DetailsTab = ({
  classObj,
  metadata,
  setSelectedLesson,
  selectedLesson,
}: DetailsTabProps) => {
  const { data: lessons } = useGetLessonsQuery({
    subject: classObj.subject, classId: classObj.classId,
  });

  const deselectLesson = () => {
    setSelectedLesson(undefined);
  };

  const handleSelect = (lesson: Lesson) => {
    if (selectedLesson?.id === lesson.id) {
      deselectLesson();
    } else {
      setSelectedLesson(lesson);
    }
  };

  return (
    <Stack direction="column" spacing={2}>
      <ClassCard classObj={classObj} classObjMetadata={metadata} />
      <StudentsCard classObj={classObj} />
      <ScheduleCard
        classObj={classObj}
        lessons={lessons?.data}
      />
      <LessonsCard
        lessons={lessons?.data}
        onSelectLesson={handleSelect}
        selectedLesson={selectedLesson}
      />
    </Stack>
  );
};
export default DetailsTab;
